import { render, staticRenderFns } from "./RiskReturnStats.vue?vue&type=template&id=448026d9&scoped=true"
import script from "./RiskReturnStats.vue?vue&type=script&lang=js"
export * from "./RiskReturnStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448026d9",
  null
  
)

export default component.exports